<h3>{{ 'GLOBAL.SETTINGS.SELECTDEPUTY' | translate }}</h3>
<br />
@if (!loading) {
  <form [formGroup]="settingsSelectDeputyForm" (ngSubmit)="clickSubmit()">
    <phscw-input-autocomplete
      [disabled]="searchDisabled"
      formControlName="deputy_autocomplete"
      [editMode]="true"
      label="{{ 'GENERAL.DEPUTY' | translate }}"
      [required]="true"
      [backendLink]="'Employees/searchEmployeeForAutoComplete'"
      (optionSelected)="selectOption()">
    </phscw-input-autocomplete>
    <br />
    <!-- Fehlermeldung bei fehlenden Untergebenen Mitarbeitern -->
    @if (showErrorNoSubordinates) {
      <p class="cw-error-message">
        {{ 'GLOBAL.SETTINGS.ERRORNOSUBORDINATES' | translate }}
      </p>
    }
    <!-- Buttons Submit & Cancel -->
    <div class="cw-button-wrapper">
      <button
        mat-raised-button
        color="accent"
        type="button"
        [disabled]="!employeeHasActiveDeputy"
        (click)="removeDeputy()">
        {{ 'GLOBAL.SETTINGS.REMOVEDEPUTY' | translate }}
      </button>
      <button mat-raised-button color="accent" type="submit" [disabled]="!saveButtonEnabled || loading || saving">
        {{ 'GENERAL.SAVE' | translate }} <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
      </button>
      <button mat-raised-button color="primary" type="button" (click)="clickAndClose()">
        {{ 'GENERAL.CANCEL' | translate }}
      </button>
    </div>
  </form>
}

<div [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>
